import React, { useMemo } from "react";
import { HorizontalBar } from "react-chartjs-2";
import { useTranslation } from "react-i18next";

const DonorDistributionByRegionChart = ({ data }) => {
  const { t } = useTranslation();

  const chartData = useMemo(() => {
    if (!data) return null;

    return {
      labels: data.regions.map((region) => t(region)),
      datasets: [
        {
          label: t("Number of Donors"),
          data: data.counts,
          backgroundColor: "#3b4cb8",
          borderColor: "#3b4cb8",
          borderWidth: 1,
          barThickness: 25,
          borderRadius: 4,
        },
      ],
    };
  }, [data, t]);

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    legend: {
      display: false,
    },
    scales: {
      xAxes: [
        {
          ticks: {
            beginAtZero: true,
            fontColor: "#666",
          },
          gridLines: {
            color: "rgba(0, 0, 0, 0.1)",
          },
          scaleLabel: {
            display: true,
            labelString: t("Number of Donors"),
            fontColor: "#666",
          },
        },
      ],
      yAxes: [
        {
          ticks: {
            fontColor: "#666",
          },
          gridLines: {
            display: false,
          },
          scaleLabel: {
            display: true,
            labelString: t("Region"),
            fontColor: "#666",
          },
        },
      ],
    },
    tooltips: {
      callbacks: {
        label: (tooltipItem) => {
          return `${t("Donors")}: ${tooltipItem.xLabel}`;
        },
      },
    },
  };

  if (!chartData) {
    return <p className="text-center mt-3">{t("No data available")}</p>;
  }

  return (
    <div style={{ minHeight: "300px", position: "relative" }}>
      <HorizontalBar data={chartData} height={300} options={options} />
    </div>
  );
};

export default DonorDistributionByRegionChart;
